export default __webpack_public_path__ + "static/media/limewit-logo.c07219f0.png";